import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts';
import { ProfileResult } from '../../types/result';

interface Props {
  result: ProfileResult;
}

const CareerList: React.FC<Props> = ({ result }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  return (
    <div className="bg-white rounded-2xl shadow-sm p-5" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Careers */}
      <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide mb-3">
        {t('result.careers')}
      </h3>
      <div className="flex flex-wrap gap-2 mb-5">
        {result.careers.map((career, i) => (
          <span
            key={i}
            className="bg-blue-50 text-scaleo-blue text-sm font-medium px-3 py-1.5 rounded-full border border-blue-100"
          >
            {career}
          </span>
        ))}
      </div>

      {/* Strengths */}
      <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide mb-3">
        {t('result.strengths')}
      </h3>
      <ul className="space-y-2 mb-5">
        {result.strengths.map((item, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
            <span className="text-green-500 mt-0.5 shrink-0">✓</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>

      {/* Watchouts */}
      <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide mb-3">
        {t('result.watchouts')}
      </h3>
      <ul className="space-y-2">
        {result.watchouts.map((item, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
            <span className="text-scaleo-orange mt-0.5 shrink-0">!</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CareerList;
